import React from 'react';

import { nanoid } from 'nanoid';
import PropTypes from 'prop-types';

import { SimpleSelect } from '~/components/selects';

import { Container } from './styles';

function Select({
  label,
  error,
  errorMessage,
  key,
  id = `_select${nanoid()}`,
  ...props
}) {
  return (
    <Container key={key}>
      <label className={error ? 'text-red-700 font-bold' : ''} htmlFor={id}>
        {label}
      </label>
      {error && (
        <span className="absolute top-2 right-0 text-xs text-red-600 ">
          {errorMessage}
        </span>
      )}
      <SimpleSelect id={id} error={error} {...props} />
    </Container>
  );
}

Select.propTypes = {
  label: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  key: PropTypes.number.isRequired,
  error: PropTypes.bool,
  errorMessage: PropTypes.string,
};

Select.defaultProps = {
  error: false,
  errorMessage: '',
};

export default Select;
